import { createAsyncThunk } from "@reduxjs/toolkit";
import config from '../../config.js'

const API_URL = config.API_URL; // URL da API

/**
 * Thunk para buscar todos os grupos.
 */
export const fetchGroups = createAsyncThunk(
  "groups/fetchGroups",
  async (_, { rejectWithValue }) => {
    try {
      const response = await fetch(`${API_URL}/group/groups`);
      if (!response.ok) {
        const errorData = await response.json().catch(() => ({ message: "Erro ao buscar grupos, resposta não OK." }));
        throw new Error(errorData.message || "Erro ao buscar grupos");
      }
      return await response.json();
    } catch (error) {
      return rejectWithValue(error.message);
    }
  }
);

/**
 * Thunk para buscar um grupo específico pelo seu ID.
 * @param {string} groupId - O ID do grupo a ser buscado.
 */
export const fetchGroupById = createAsyncThunk(
  "groups/fetchGroupById", // Nome do thunk atualizado para clareza
  async (groupId, { rejectWithValue }) => {
    try {
      const response = await fetch(`${API_URL}/group/group/${groupId}`); // URL corrigida com ID
      if (!response.ok) {
        const errorData = await response.json().catch(() => ({ message: `Erro ao buscar o grupo ${groupId}, resposta não OK.` }));
        throw new Error(errorData.message || `Erro ao buscar o grupo com ID ${groupId}`);
      }
      return await response.json();
    } catch (error) {
      return rejectWithValue(error.message);
    }
  }
);

/**
 * Thunk para criar (salvar) um novo Grupo.
 * Campos atuais: groupName, groupDescription, selectedDashboards, selectedUsers.
 * Adapte os campos conforme a necessidade da sua API para criação.
 */
export const saveGroup = createAsyncThunk(
  "groups/saveGroup",
  async (groupData, { rejectWithValue }) => {
    const { groupName, selectedDashboards, selectedUsers } = groupData;
    try {
      const response = await fetch(`${API_URL}/group/group`, {
        method: "POST",
        headers: { "Content-Type": "application/json" },
        body: JSON.stringify({
          groupName,
          selectedDashboards, 
          selectedUsers         
        }),
      });

      const data = await response.json();
      if (!response.ok) {
        throw new Error(data.message || "Erro ao salvar grupo");
      }
      return data;
    } catch (error) {
      return rejectWithValue(error.message);
    }
  }
);

/**
 * Thunk para atualizar um Grupo existente.
 * @param {object} groupData - Dados do grupo para atualizar.
 * Deve incluir 'id' (ou 'uid') e outros campos: { id, groupName, readers, dashboardsId }
 */
export const updateGroup = createAsyncThunk(
  "groups/updateGroup",
  async (groupData, { rejectWithValue }) => {
    const { id, groupName, readers, dashboardsId } = groupData;
    
    if (!id) {
      return rejectWithValue("ID do grupo é obrigatório para atualização.");
    }
    
    try {
      const response = await fetch(`${API_URL}/group/group/${id}`, {
        method: "PUT",
        headers: { "Content-Type": "application/json" },
        body: JSON.stringify({
          groupName,
          selectedUsers: readers,      
          selectedDashboards: dashboardsId  
        }),
      });

      const data = await response.json();
      if (!response.ok) {
        throw new Error(data.message || "Erro ao atualizar grupo");
      }
      return data;
    } catch (error) {
      return rejectWithValue(error.message);
    }
  }
);

/**
 * Thunk para deletar um Grupo.
 * @param {string} groupId - O ID do grupo a ser deletado.
 */

export const deleteGroup = createAsyncThunk(
  "groups/deleteGroup",
  async (groupId, { rejectWithValue }) => {
    try {
      const response = await fetch(`${API_URL}/group/group/${groupId}`, {
        method: "DELETE",
      });
      if (!response.ok) {
        const errorData = await response.json().catch(() => ({ message: `Erro ao deletar o grupo ${groupId}, resposta não OK.` }));
        throw new Error(errorData.message || `Erro ao deletar o grupo com ID ${groupId}`);
      }
      return groupId; // Retorna o ID para que o reducer possa remover o item
    } catch (error) {
      return rejectWithValue(error.message);
    }
  }
);